module.exports = __webpack_public_path__ + "static/media/gift4.19a0771a.jpg";